import { FlexBox } from '@airship-platform/jam-web/components';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { NavLink, Outlet, useLocation } from 'react-router';
import { useAppointments } from '../../../data-access/appointments';
import ROUTE_PATHS from '../../../routes/paths';

const tabItems = [
  {
    label: 'Upcoming jobs',
    value: ROUTE_PATHS.SCHEDULE,
  },
  {
    label: 'Past jobs',
    value: ROUTE_PATHS.SCHEDULE_SEARCH,
  },
];

const SchedulePage: React.FC = () => {
  const location = useLocation();
  const { isLoading } = useAppointments();

  return (
    <FlexBox flexDirection={'column'} gap={3}>
      <FlexBox alignItems={'center'} justifyContent={'space-between'} gap={2}>
        <Typography variant="h2" color={'textPrimary'}>
          {'Your schedule'}
        </Typography>
        {isLoading && <CircularProgress color="primary" size="1.5rem" />}
      </FlexBox>

      <FlexBox flexDirection={'column'}>
        <Tabs value={location.pathname}>
          {tabItems.map((item) => (
            <Tab
              component={NavLink}
              to={item.value}
              key={item.value}
              label={item.label}
              value={item.value}
            />
          ))}
        </Tabs>
        <Divider flexItem />
      </FlexBox>

      <Outlet />
    </FlexBox>
  );
};

export default SchedulePage;
